import { render } from "./cxeclButVxe.vue?vue&type=template&id=01587196"
import script from "./cxeclButVxe.vue?vue&type=script&lang=js"
export * from "./cxeclButVxe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__